/**
 * Subpath where the app is hosted on customdev (see package.json `homepage`).
 * CRA sets `PUBLIC_URL` from `homepage` in production builds; dev server uses `/`.
 */
export function getRouterBasename() {
  if (process.env.NODE_ENV === "development") {
    return "";
  }
  const p = process.env.PUBLIC_URL || "";
  return String(p).replace(/\/$/, "");
}
